export default {
    incoming: 'Incoming',
    outgoing: 'Outgoing',
};
